export default {
    invitation_errors: [
        {
            text: 'برای ارسال دعوت باید یک تیم داشته باشید'
        },
        {
            text: 'این فرد از قبل در این تیم حضور دارد'
        },
        {
            text: 'دعوت قبلی این فرد هنوز توسط وی پاسخ داده نشده'
        }
    ],
    sent_invitations_headers: [
        {
            text: 'دعوت شده', value: 'invited'
        },
        {
            text: 'تاریخ ارسال', value: 'date_created'
        }, {
            text: 'وضعیت', value: 'status'
        },
        {
            text: '', value: 'delete'
        },


    ],
    received_invitations_headers: [
        {
            text: 'ارسال کننده', value: 'invitor'
        },
        {
            text: 'تاریخ ارسال', value: 'date_created'
        }, {
            text: 'وضعیت', value: 'status'
        },
        // {
        //     text:'نام تیم',value:'team'
        // },
        {
            text: "", value: "action"
        },


    ],
    orders_history_headers: [
        {
            text: 'وضعیت', value: 'order_state'
        },
        {
            text: 'توضیحات', value: 'reason'
        },
        {
            text: 'توسط', value: 'user'
        },
        {
            text: 'توضیحات', value: 'description'
        },
        {
            text: 'سهام', value: 'ticker_symbol.full_name'
        },
        {
            text: 'نوع', value: 'order_type'
        },
        {
            text: 'قیمت واحد', value: 'price'
        },
        {
            text: 'مقدار', value: 'quantity'
        },
        {
            text: 'تاریخ ثبت', value: 'date_created'
        }
    ],
    portfolio_headers: [
        {
            text: 'نام کامل', value: 'ticker_symbol.full_name'
        },
        {
            text: 'ISIN', value: 'ticker_symbol.isin'
        },
        {
            text: 'نام کوتاه', value: 'ticker_symbol.short_name'
        },
        {
            text: 'تعداد', value: 'quantity'
        },
        {
            text: 'ارزش واحد', value: 'ticker_symbol.close'
        },
        {
            text: 'ارزش کل', value: 'total_value'
        },
    ],
    grades: [
        // {text: 'زیر دیپلم', value: 'U'},
        {text: 'دیپلم', value: 'D'},
        {text: 'کاردانی', value: 'A'},
        {text: 'کارشناسی', value: 'B'},
        {text: 'کارشناسی ارشد', value: 'M'},
        {text: 'دکترا', value: 'P'},
    ],
    months: [
        {text: 'فروردین', value: 1},
        {text: 'اردیبهشت', value: 2},
        {text: 'خرداد', value: 3},
        {text: 'تیر', value: 4},
        {text: 'مرداد', value: 5},
        {text: 'شهریور', value: 6},
        {text: 'مهر', value: 7},
        {text: 'آبان', value: 8},
        {text: 'آذر', value: 9},
        {text: 'دی', value: 10},
        {text: 'بهمن', value: 11},
        {text: 'اسفند', value: 12},
    ],
    profit_headers: [
        {text: "رتبه", value: "rank"},
        {text: "تیم", value: "team.name"},
        {text: "موسسه", value: "team.organization"},
        {text: "سود", value: "profit"},
        {text: "درصد سود", value: "profit_percentage"},
    ],
}